// extracted by mini-css-extract-plugin
export default {"label":"WheelEcoLabel__label--S7OlD","icon":"WheelEcoLabel__icon--tcLBh","score":"WheelEcoLabel__score--PJq8J"};